import { useStatsRefresh } from '../api/hooks.js';
import { formatExactTime } from '../util/format.js';

/**
 * When the numbers on this page were last rebuilt, and whether they are being
 * rebuilt right now.
 *
 * Sits top right on the stats and standings pages. A recalculation rewrites
 * every table underneath it, so a reader who arrives mid-run is looking at
 * numbers that are about to change — saying so is the whole point.
 */
export function StatsFreshness() {
  const { data } = useStatsRefresh();
  if (!data) return null;

  if (data.running) {
    return (
      <p
        className="flex items-center gap-2 border border-brass-400 px-2 py-1 font-display text-xs
          font-semibold uppercase tracking-bug text-brass-300"
        role="status"
      >
        <span aria-hidden className="h-2 w-2 shrink-0 animate-pulse rounded-full bg-brass-400" />
        <span>
          Recalculating now
          {data.startedAt ? <> · started {formatExactTime(data.startedAt)}</> : null}
        </span>
      </p>
    );
  }

  return (
    <p
      className="font-display text-xs font-semibold uppercase tracking-bug text-field-500"
      role="status"
    >
      {data.lastCompletedAt
        ? `Stats last calculated ${formatExactTime(data.lastCompletedAt)}`
        : 'Stats have not been calculated yet'}
      {data.lastFailed ? <span className="ml-1 text-signal">· the last run failed</span> : null}
    </p>
  );
}
